export const isValidSelector = (() => {
  if (typeof CSS !== "undefined" && CSS.supports?.("selector(*)")) {
    return (selector: string) => CSS.supports(`selector(${selector})`);
  }
  const fragment = document.createDocumentFragment();
  return (selector: string) => {
    try {
      fragment.querySelector(selector);
      return true;
    } catch {
      return false;
    }
  };
})();
